/* eslint-disable max-len */
import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { Box, Button, Container, Divider, Grid, Link, Typography } from '@material-ui/core';
import ReactMarkdown from 'react-markdown';
import moment from 'moment';

// Styles
const useStyles = makeStyles((theme) => ({
  body: {
    marginTop: -100,
  },
  bodyText: {
    fontFamily: 'Flama-Book',
    fontSize: '18px',
    lineHeight: 1.7,
  },
  bodyTextSmall: {
    marginTop: 30,
    fontFamily: 'Flama-Book',
    fontSize: '14px',
    fontStyle: 'italic',
    lineHeight: 1.7,
  },
  profilePicture: {
    width: '150px',
    height: '150px',
    borderRadius: '150px',
    position: 'relative',
    overflow: 'hidden',
  },
  bold: {
    fontWeight: 'bold',
  },
  otherArticlesPicture: {
    width: '100%',
    height: '150px',
    position: 'relative',
    overflow: 'hidden',
  },
  pressReleaseText: {
    fontWeight: 'Bold',
    color: theme.palette.gray.dark,
    fontSize: 16,
    [theme.breakpoints.between('0', '600')]: {
      fontSize: 12,
      fontWeight: 0,
    },
  },
  caption: {
    color: theme.palette.gray.dark,
    fontSize: 16,
    marginRight: 20,
    [theme.breakpoints.between('0', '600')]: {
      fontSize: 12,
    },
  },
  imageTag: {
    display: 'inline-block',
    width: '100%',
    height: '100%',
    layout: 'fill',
    objectFit: 'cover',
  },
}));

const Body = (props) => {
  const classes = useStyles();
  const { data } = props;
  const otherNewsArticles = data.newsArticles.filter((obj) => obj.id !== data.newsArticle.id);

  return (
    <Box>
      <Container maxWidth="lg" className={classes.body}>
        <Grid container>
          <Grid item xs={12}>
            <ReactMarkdown className={classes.bodyText}>{data.newsArticle.body}</ReactMarkdown>
            <ReactMarkdown className={classes.bodyTextSmall}>{data.newsArticle.subBody}</ReactMarkdown>
            <Divider />
          </Grid>
          <Grid item xs={12}>
            <Box mt={3} />
            <Typography variant="h6">Other articles</Typography>
            <Grid item container spacing={2}>
              {otherNewsArticles.slice(0, 3).map((item) => (
                <Grid
                  item
                  xs={12}
                  md={4}
                  container
                  direction="column"
                  key={item.id}
                >
                  <Box mt={4} />
                  <Box className={classes.otherArticlesPicture}>
                    <img
                      src={item ? item.picture.url : '/'}
                      className={classes.imageTag}
                      alt="News article"
                    />
                  </Box>
                  <Box mt={1} />
                  <Typography variant="subtitle2" className={classes.bold}>{item.title}</Typography>
                  <Box mt={1} />
                  <Box flexDirection="row" display="flex">
                    <Typography variant="caption" className={classes.caption}>{moment(item.publishedDate).format('YYYY-MM-DD - HH:mm')}</Typography>
                    <Typography className={classes.pressReleaseText} variant="caption" color="secondary">{item.tag}</Typography>
                  </Box>
                  <Box mt={2} />
                  <Typography variant="body1">{item.preamble}</Typography>
                  <Box mt={1} />
                  <Link href={`/news/${item.id}`}>
                    <Button variant="contained" className={classes.button} size="large" color="primary">
                      Read more
                    </Button>
                  </Link>
                </Grid>
              ))}
            </Grid>
          </Grid>
        </Grid>
      </Container>
    </Box>
  );
};

export default Body;
